export default class Slider{

    static init(){
        let sliders = document.getElementsByClassName('slider')
        for(let slider of sliders){
            new Slider(slider).init()
        }
    }

    elem
    #interval
    #wrapper
    #items
    #controls
    #delay 
    #step = 100
    #count = 0
    #isAuto = false
    #direction = 'X'
    #transform = 0
    #pos=0


    constructor(sliderElem){
        this.elem = sliderElem
    }

    init(){
        try{
            this.#wrapper = this.elem.querySelector('.slider__wrapper')
            if (!this.#wrapper)
                throw new Error('Slider must have wrapper for correct work!')
            this.#items = this.#wrapper.getElementsByClassName('slider__item')
            this.#delay = this.elem.getAttribute('data-delay') ?? 1000
            this.#isAuto = this.elem.getAttribute('data-mode') == 'auto' ? true : false
            let controlElems = Array.from(document.getElementsByClassName('slider__controls'))
                .filter(elem => elem.getAttribute('data-target') == this.elem.id)
            if (controlElems.length) {
                this.#controls = controlElems.reduce((acc, elem) => acc = [...acc, ...Array.from(elem.getElementsByClassName('slider__btn'))], [])
                this.#controls.forEach(btn => btn.addEventListener('click', this.actionClick.bind(this)))
            }
            return true
        }catch(err){
            console.error(err)
            return false
        }
    }

    slide(isNext=true){
        let rect = this.#wrapper.getBoundingClientRect();
        let rectItem = this.#items[0].getBoundingClientRect();
        let offset = Math.round(rect.width / rectItem.width);
        offset = offset<=1 ? 0 : offset
        this.#step = (rectItem.width / rect.width) * 100;

        let j = offset == 0 ? 1 : offset;

        if (isNext) {
            this.#transform += this.#step;
            this.#wrapper.style.transform = "translateX(" + this.#transform + "%)";
            this.#count--;
            this.#pos--;
            if (this.#pos == -1) {
                this.#pos = this.#items.length - 1;
            }
        } else {
            this.#transform -= this.#step;
            this.#wrapper.style.transform = "translateX(" + this.#transform + "%)";
            this.#count++;
            this.#pos++;
            if (this.#pos == this.#items.length) {
                this.#pos = 0;
            }
        }

        let multi,k
        if (isNext) {
            k = this.#pos;
            multi = Math.floor((this.#count) / this.#items.length);
        } else {
            k = this.#pos + offset;
            multi = Math.floor((this.#count + offset) / this.#items.length);
        }
        if (k >= this.#items.length) {
            k = Math.abs(this.#items.length - this.#pos - offset);
        }
        if (k <= -1) {
            k = this.#items.length - k;
        }

        this.#items[k].style.transform = "translateX(" + (this.#items.length * this.#step * multi * j) + "%)";
            
        if (this.#controls.length != 0) {
            for (let i = 0; i < this.#controls.length; i++) {
                if (i == this.#pos) 
                    this.#controls[i].classList.add('slider__btn_active');
                else 
                    this.#controls[i].classList.remove('slider__btn_active');
            }
        }
    }

    actionClick(event){
		let targetPos;
		for(let i=0;i<this.#controls.length;i++){
			if(event.currentTarget==this.#controls[i]){
				targetPos=i;
				break;
			}
		}
        let oldPos = this.#pos
		if(targetPos<this.#pos){
			for(let i=0;i<oldPos-targetPos;i++){
				this.slide(true);
			}
		}else{
			for(let i=0;i<targetPos-oldPos;i++){
				this.slide(false);
			}
		}
	}

}